<template>
	<div class="container">
		<!--页面开始-->
		<div class="check_result">
			<div class="top_box">
				<div class="top_tip">
					请在20分钟内完成选择，否则结果可能不准确，且会返回操作首页。
				</div>
			</div>
			<div class="step_box">
				<div class="res_box">
					<div>
						<van-image
						  width="100%"
						  height="auto"
						  lazy-load
						  show-loading
						  :src="require('@/assets/img/check_c.webp')"
						>
							<template v-slot:loading>
								<div class="wrap color-A">
									<div class="k-line k-lineA-1"></div>
									<div class="k-line k-lineA-2"></div>
									<div class="k-line k-lineA-3"></div>
									<div class="k-line k-lineA-4"></div>
								</div>
							</template>
						</van-image>
					</div>
					<!--写文字-->
					<div class="step_txt">
						C区是否出现一条色带？
					</div>
					<!--写文字-->
					<div class="check_box">
						<van-radio-group v-model="Cline" direction="horizontal" @change="ClineClick">
						  <van-radio name="Yes" shape="square" icon-size="0.38rem" checked-color="#0078FF">是</van-radio>
						  <van-radio name="No" shape="square" icon-size="0.38rem" checked-color="#0078FF">否</van-radio>
						</van-radio-group>
					</div>
				</div>
				<div class="res_box">
					<div>
						<van-image
						  width="100%"
						  height="auto"
						  lazy-load
						  show-loading
						  :src="require('@/assets/img/check_t.webp')"
						>
							<template v-slot:loading>
								<div class="wrap color-A">
									<div class="k-line k-lineA-1"></div>
									<div class="k-line k-lineA-2"></div>
									<div class="k-line k-lineA-3"></div>
									<div class="k-line k-lineA-4"></div>
								</div>
						    </template>
						</van-image>
					</div>
					<!--写文字-->
					<div class="step_txt">
						T区是否出现一条色带？
					</div>
					<!--写文字-->
					<div class="check_box">
						<van-radio-group v-model="Tline" direction="horizontal" @change="TlineClick">
						  <van-radio name="Yes" shape="square" icon-size="0.38rem" checked-color="#0078FF">是</van-radio>
						  <van-radio name="No" shape="square" icon-size="0.38rem" checked-color="#0078FF">否</van-radio>
						</van-radio-group>
					</div>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				v-if="isCheck"
				type="primary"
				block
				round
				color="#b5b4c2"
			>
				下一步
			</van-button>
			<van-button
				v-else
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goresult"
			>
				下一步
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			isCheck: true,
			Cline: null,
			Tline: null,
			timer: null,
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		this.$toast.loading({
			duration: 0,
		});
	},
	mounted() {
		let that = this;
		that.$toast.clear();
		//判断是否开启5分钟倒计时
		if(sessionStorage.getItem('countDown') === 'true'){
			that.timer = setTimeout(function() {
				that.$dialog.confirm({
				  title: '确认',
				  message: '读取结果超时，请重新测试',
				  confirmButtonText: '确定',
				  confirmButtonColor: '#333333',
				  showCancelButton: false,
				}).then(() => {
					//window.location.href = 'https://helper.aiiso.net/xieyi/#/spain/stepOne';
				    that.$router.push({path: '/chinese/stepOne'});
				}).catch(() => {
				    // on cancel
				});
			}, 20 * 60 *1000);
		}
		//读取上次存储结果
		if(sessionStorage.getItem('cValue') && sessionStorage.getItem('tValue')){
			that.Cline = sessionStorage.getItem('cValue');
			that.Tline = sessionStorage.getItem('tValue');
			that.isCheck = true;
		}
	},
	watch: {
		//
	},
	methods: {
		//C线选择
		ClineClick(event) {
			let that = this;
			if(that.Cline && that.Tline) {
				that.isCheck = false;
			}
		},
		//T线选择
		TlineClick() {
			let that = this;
			if(that.Cline && that.Tline) {
				that.isCheck = false;
			}
		},
		//进入检测结果
		goresult(value) {
			let that = this;
			if(that.Cline && that.Tline) {
				//window.location.href = 'https://helper.aiiso.net/xieyi/#/spain/stepEight?cline=' + that.Cline + '&tline=' + that.Tline;
				sessionStorage.setItem('cValue', that.Cline);
				sessionStorage.setItem('tValue', that.Tline);
				this.$router.push({path: '/chinese/stepEight', query: {'cline': that.Cline, 'tline': that.Tline}});
			}
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		if(this.timer){
			clearTimeout(this.timer);
		}
		sessionStorage.removeItem('countDown');
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.check_result{
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.top_box{
	padding: 0.48rem;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	background-color: #ffffff;
	border: 1px solid #E9E9E9;
}
.top_tip{
	/* margin: 0rem 0.6rem 0 0.6rem; */
	padding: 0.25rem 0.45rem;
	background-color: #ffcaca;
	font-size: 0.347rem;
	color: #720000;
	border-radius: 8px;
	border: 1px #720000 solid;
	font-weight: bold;
}
.step_box{
	/* padding: 0.2135rem 0.3rem 0rem 0.3rem; */
}
.step_box img{
	width: 100%;
}
.check_box{
	padding-top:0.4rem;
	display: flex;
	justify-content: center;
}
>>> .check_box .van-radio{
	margin:0 1.8rem 0 0.9rem;
}
.res_box{
	padding: 0.64rem 0 0.64rem 0;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	background-color: #ffffff;
	border: 1px solid #E9E9E9;
}
.res_box:last-child{
	margin-bottom: 0;
}
.btn_box{
	padding: 0.64rem 0.9rem 0.667rem 0.9rem;
	/* position: fixed;
	bottom: 0.667rem;
	width: 100%;
	padding: 0 0.9rem 0 0.9rem; */
}
.btn_box img{
	width: 100%;
}

.step_txt{
	padding: 0.4rem 0.4rem 0 0.4rem;
}

>>> .van-radio__icon--checked + .van-radio__label{color: #0078FF;}
>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

/* @media screen and (min-device-width : 768px){
	.btn_box{
		position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem;
	}
} */
</style>
